import React, { createContext, useContext } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import useEffectOnUpdates from 'hooks/use-effect-on-updates';

import { IUseLoyalty, IUseLoyaltyRewards } from './hooks/types';
import { useLoyalty } from './hooks/use-loyalty';
import { useLoyaltyRewards } from './hooks/use-loyalty-rewards';
import { ThLoyaltyProvider } from './th-loyalty-context';

// Leaving as an interface to be extended in future PR
export interface ILoyaltyContext extends IUseLoyalty, IUseLoyaltyRewards {}

export const LoyaltyContext = createContext({} as ILoyaltyContext);
export const useLoyaltyContext = () => useContext(LoyaltyContext);

export const LoyaltyProvider = (props: IBaseProps) => {
  const { loyaltyEnabled, loyaltyUser, loyaltyLoading, refetchLoyaltyUser } = useLoyalty();
  const {
    applyReward,
    appliedLoyaltyRewards,
    stagedCartPoints,
    unApplyReward,
    createAvailableLoyaltyRewardsMap,
    availableLoyaltyRewardsMap,
    resetLoyaltyRewardState,
    appliedLoyaltyRewardsArray
  } = useLoyaltyRewards(loyaltyUser);
  const loyaltyUserId = loyaltyUser?.id;

  useEffectOnUpdates(() => {
    if (!loyaltyEnabled) {
      resetLoyaltyRewardState();
    }
  }, [loyaltyEnabled, resetLoyaltyRewardState]);

  // Reset rewards on loyalty user change
  useEffectOnUpdates(() => {
    resetLoyaltyRewardState();
  }, [loyaltyUserId, resetLoyaltyRewardState]);

  return (
    <LoyaltyContext.Provider
      value={{
        appliedLoyaltyRewardsArray,
        loyaltyEnabled,
        loyaltyUser,
        loyaltyLoading,
        stagedCartPoints,
        appliedLoyaltyRewards,
        applyReward,
        unApplyReward,
        createAvailableLoyaltyRewardsMap,
        availableLoyaltyRewardsMap,
        resetLoyaltyRewardState,
        refetchLoyaltyUser
      }}
    >
      {/* To be deprecated and replaced with generic LoyaltyContext after api migration is complete */}
      <ThLoyaltyProvider>{props.children}</ThLoyaltyProvider>
    </LoyaltyContext.Provider>
  );
};
